import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { withStyles } from '@material-ui/core/styles';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';

import hexToRgb from 'styles/hexToRgb';

const styles = theme => ({
  root: {
    position: 'static',
  },
  formControlLabel: {
    position: 'absolute',
    margin: 0,
  },
  checkboxRoot: {
    width: '100%',
    height: '100%',
    '& *': {
      width: '100%',
      height: '100%',
    },
    '&:before': {
      content: '""',
      display: 'block',
      position: 'absolute',
      top: -2,
      right: -2,
      bottom: -2,
      left: -2,
      zIndex: 1,
    },
  },
  checkboxIcon: {
    backgroundColor: `rgba(${hexToRgb(theme.palette.grey[900])}, 0.05)`,
    width: '100%',
    height: '100%',
  },
  checkboxIconChecked: {
    backgroundColor: theme.palette.text.primary,
  },
  checkboxIconCheckedOutline: {
    backgroundColor: `rgba(${hexToRgb(theme.palette.grey[900])}, 0.05)`,
    border: `1px solid ${theme.palette.text.primary}`,
  },
});

const DocumentPreviewFillCheckboxField = ({
  input, x, y, width, height, documentPrintWidth, documentPrintHeight, outline, classes,
}) => (
  <FormControlLabel
    className={classes.formControlLabel}
    control={(
      <Checkbox
        classes={{
          root: classes.checkboxRoot,
        }}
        disableRipple
        name={input.name}
        checked={input.value || false}
        onChange={input.onChange}
        color="primary"
        inputProps={{
          id: input.name,
        }}
        icon={(<div
          className={classes.checkboxIcon}
        />)}
        checkedIcon={(<div
          className={classNames(classes.checkboxIconChecked, {
            [classes.checkboxIconCheckedOutline]: outline,
          })}
        />)}
      />
    )}
    style={{
      left: `${(x / documentPrintWidth) * 100}%`,
      top: `${(y / documentPrintHeight) * 100}%`,
      ...width ? { width: `${((width / documentPrintWidth) * 100)}%` } : {},
      ...height ? { height: `${(height / documentPrintHeight) * 100}%` } : {},
    }}
  />
);

DocumentPreviewFillCheckboxField.propTypes = {
  input: PropTypes.shape({
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.bool,
    ]).isRequired,
  }).isRequired,
  x: PropTypes.number.isRequired,
  y: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  documentPrintWidth: PropTypes.number.isRequired,
  documentPrintHeight: PropTypes.number.isRequired,
  outline: PropTypes.bool,
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
    formControlLabel: PropTypes.string.isRequired,
    checkboxRoot: PropTypes.string.isRequired,
    checkboxIcon: PropTypes.string.isRequired,
    checkboxIconChecked: PropTypes.string.isRequired,
    checkboxIconCheckedOutline: PropTypes.string.isRequired,
  }).isRequired,
};

DocumentPreviewFillCheckboxField.defaultProps = {
  outline: false,
};

export default withStyles(styles)(DocumentPreviewFillCheckboxField);



// WEBPACK FOOTER //
// ./src/components/common/DocumentPreviewFillForm/DocumentPreviewFillCheckboxField.js